/* eslint-disable */
import { Route, Routes, Navigate } from 'react-router-dom';
import OfferHomePage from './Components/OfferHomePage';
import SignInOidc from './Components/SignInOidc';
import Login from './Components/Login';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import theme from './Styles/theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/" element={<Login />}></Route>
        <Route path="/offer-market" element={<OfferHomePage />}></Route>
        <Route path="/signin-oidc" element={<SignInOidc />}></Route>
        <Route path="*" element={<Navigate to="/offer-market" replace />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
